var config = require('../config');

var Logger = {
    error: function() {
        log(arguments, 'error');
    },
    warn: function() {
        log(arguments, 'warn');
    },
    debug: function() {
        log(arguments, 'debug');
    },
    info: function() {
        log(arguments, 'info');
    },
    log: function() {
        log(arguments, 'info');
    }
};

function log(messages, level) {
    var logger = console[level].bind(console);
    if (config.environment === 'development') {
        var stack = new Error().stack; // Does not seem to work in IE11
        if (stack) {
            // console.log(stack);
            var stackSplit = stack.split('\n');
            console[level](stack
                .replace(stackSplit[0], level.charAt(0).toUpperCase() + level.slice(1))
                .replace(stackSplit[1] + '\n', '')
                .replace(stackSplit[2] + '\n', ''));
        }
        logger.apply(null, messages);
    }
}

module.exports = Logger;



// WEBPACK FOOTER //
// ./src/util/logger_utils.js